import { defineComponent, onMounted, toRef } from 'vue';
import { ProviderFormField } from './provider-form-field';
import { ProviderEditor } from './provider-editor.class';
import { ProviderType } from '../enums/provider-type';

export default defineComponent({
	props: {
		modelValue: ProviderFormField,
	},
	setup: (props) => {
		const code = new ProviderEditor(toRef(props, 'modelValue'));

		onMounted(async () => await code.mounted());

		return {
			ProviderType,
			organisations: code.organisations,
			bodies: code.bodies,
			organisationsRemoteSearch: code.organisationsRemoteSearch.bind(code),
			bodiesRemoteSearch: code.bodiesRemoteSearch.bind(code),
		};
	},
});
